const LOAD_DETAIL_VILLAGE           = 'LOAD_DETAIL_VILLAGE'
const LOAD_DETAIL_VILLAGE_SUCCESS   = 'LOAD_DETAIL_VILLAGE_SUCCESS'
const LOAD_DETAIL_VILLAGE_FAILED    = 'LOAD_DETAIL_VILLAGE_FAILED'
const UNMOUNT_DETAIL_VILLAGE        = 'UNMOUNT_DETAIL_VILLAGE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const villageDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_VILLAGE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_VILLAGE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_VILLAGE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_VILLAGE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default villageDetailReducer;